import {
  fetchNewsFail,
  fetchNewsRequest,
  fetchNewsSuccess,
  fetchTickerNewsSuccess
} from '../store/ActionReducers/news.actionreducer';
import { Dispatch } from 'redux';
import { httpbase } from '../utils/axios.utils';
import { lang } from '../config/app.config';


export const fetchNews = (page: number = 1, branch: string | null = null) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchNewsRequest());
    try {
      const response = await httpbase().get(`resources/news/?lang=${lang}&page=${page}${branch ? '&branch=' + branch : ''}`);
      const news = response.data.data || undefined;
      const meta = response.data.meta || undefined;
      const important = response?.data?.important || undefined;
      // console.log('important news', important)
      dispatch(fetchNewsSuccess({ news: news, meta: meta, important: important }));
    } catch (e: any) {
      if (e && e.response && e.response.data) {
        dispatch(fetchNewsFail(e.response.data));
      }
      dispatch(fetchNewsFail("Something went wrong!"));
    }
  }
}

export const fetchTickerNews = (page: number = 1, branch: string | null = null) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchNewsRequest());
    try {
      // const response = await httpbase().get(`resources/news/?lang=${lang}&page=${page}${branch ? '&branch=' + branch : ''}`);
      const response = await httpbase().get(`resources/ticker-news/?lang=${lang}&page=${page}${branch ? '&branch=' + branch : ''}`);
      // console.log('ticker news response', response)
      const news = response.data.data || undefined;
      // const important = response?.data?.important || undefined
      dispatch(fetchTickerNewsSuccess({ news: news }));
    } catch (e: any) {
      dispatch(fetchNewsFail("Something went wrong!"));
    }
  }
}


export const fetchNewsBySlug = async (slug: string) => {
  try {
    const response = await httpbase().get(`resources/news/${slug}?lang=${lang}`);
    return response.data.data;
  } catch (e) {
    console.log(e);
  }
}